import { API } from "../../../backend";
import { objectToQueryString } from "../../../lib/utils";

export const getExpense=(userId,token,expenseId)=>{
  return fetch(`${API}/expense/${userId}/${expenseId}`,{
    method:'get',
    headers:{
      Accept:"application/json",
      Authorization:`Bearer ${token}`
    }
  }).then(res=>{
    return res.json();
  }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const getExpenseCount=(userId,token,query)=>{
  let str=objectToQueryString(query);
  return fetch(`${API}/expenses/count/${userId}?${str}`,{
    method:'get',
    headers:{
      Accept:'application/json',
      Authorization:`Bearer ${token}`
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const  getAllExpense=(userId,token,query)=>{
  let str=objectToQueryString(query);
  return fetch(`${API}/expenses/${userId}?${str}`,{
    method:'get',
    headers:{
      Accept:'application/json',
      Authorization:`Bearer ${token}`
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const  getTotalExpenseAmount=(userId,token,query)=>{
  let str=objectToQueryString(query);
  return fetch(`${API}/total/expense-amount/${userId}?${str}`,{
    method:'get',
    headers:{
      Accept:'application/json',
      Authorization:`Bearer ${token}`
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const addExpense=(userId,token,formData)=>{
  return fetch(`${API}/expense/create/${userId}`,{
    method:"post",
    headers:{
      Accept:"application/json",
      Authorization:`Bearer ${token}`
    },
    body:formData
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}



export const updateExpense=(userId,token,expenseId,body)=>{
  return fetch(`${API}/expense/update/${userId}/${expenseId}`,{
    method:'put',
    headers:{
      Accept:"application/json",
      Authorization:`Bearer ${token}`
    },
    body:body
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const removeExpense=(userId,token,body)=>{
  return fetch(`${API}/expense/bulk/delete/${userId}`,{
    method:'POST',
    headers:{
      Accept:"application/json",
      'Content-Type':'application/json',
      Authorization:`Bearer ${token}`
    },
    body:JSON.stringify(body)
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}